import { Box, Button, FormControlLabel, IconButton, InputBase, Modal, TextField, Tooltip, Typography, Switch } from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import { InventoryDetailsTable } from "../../sub_components/inventoryDetails_table";
import { useDispatch, useSelector } from "react-redux";
import { updateInventory, updateInventoryDetail, updateInventoryDetailsModal, updateInventrySupervisors, updateInventryAdmins, updateInventryCustomerEngagementAdmins, updateInventryCashiers, updateInventryHubsupervisors, updateallInventryDetails, updateinventoryDetailsEdit, updateInventoryModal, updateinventoryEdit, updateInventoryform, updateInventoryDetailsLoading, updateInventorySearchProduct, updateFranchises, updateStallModal, updateStallForm, updateStallEdit, resetStallForm, updateSelectedStallId, updateStalls } from "../../Redux/inventory";
import { updateSelectedHub } from "../../Redux/user";
import { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { Dropdown } from "primereact/dropdown";
import { updateProducts } from "../../Redux/products";
import { MultiSelect } from 'primereact/multiselect';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Toast } from "primereact/toast";
import { useRef } from "react";
import { InventoryTable } from "../../sub_components/inventory_table";
import { StallTable } from "../../sub_components/stall_table";
import CustomAxios from "../../utils/CustomAxios";
import * as Yup from "yup";
import { OrderDetailsModal, useDateformate, useGetInventory, useGetInventoryDetails, useGetProducts } from "../globalFunctions";
import { updateUpdatedDate } from "../../Redux/orders";
import CircularProgress from '@mui/material/CircularProgress';
import { LocalizationProvider, DatePicker, MobileTimePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { updatepageName } from "../../Redux/page";
import { InputSwitch } from "primereact/inputswitch";
import "../../App.css";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { describeServerErrors } from './serverErrors';

export function Inventory() {
    const toast = useRef(null);
    const inventoryDetails = useSelector(state => state.inventory.inventory_detail)
    const allinventoryDetails = useSelector(state => state.inventory.allInventryDetails)
    const inventoryForm = useSelector(state => state.inventory.inventoryForm)
    const inventory = useSelector(state => state.inventory.inventory)
    const supervisors = useSelector(state => state.inventory.supervisors)
    const admins = useSelector(state => state.inventory.admins)
    const customerEngagementAdmins = useSelector(state => state.inventory.customerEngagementAdmins)
    const cashiers = useSelector(state => state.inventory.cashiers)
    const franchises = useSelector(state => state.inventory.franchises)
    const InventoryEdit = useSelector(state => state.inventory.inventoryEdit)
    const inventoryModal = useSelector(state => state.inventory.modal);
    const stallModal = useSelector(state => state.inventory.stallModal);
    const stallForm = useSelector(state => state.inventory.stallForm);
    const stallEdit = useSelector(state => state.inventory.stallEdit);
    const selectedStallId = useSelector(state => state.inventory.selectedStallId);
    const selectedHub = useSelector(state => state.user.selected_hub);
    const user_role = localStorage.getItem('role');
    
    // Check if user can manage inventory (create, edit, delete)
    const canManageInventory = ['super_admin', 'admin', 'supervisor'].includes(user_role);
    const canViewInventory = ['super_admin', 'admin', 'supervisor', 'customer_engagement_admin'].includes(user_role);
    
    // Helper function to determine if a field should be disabled for supervisors
    const isFieldDisabledForSupervisor = (fieldName) => {
        if (user_role !== 'supervisor') return inventoryform.isViewOnly;
        
        // Fields that supervisors can edit
        const editableFields = [
            'shop_open_at', 
            'shop_close_at', 
            'delivery_fee', 
            'delivery_mini_spent', 
            'delivery_status', 
            'self_pickup_waiver', 
            'self_pickup_waiver_percentage',
            'cashier_ids',
            'signup_offer_status',
            'promised_delivery_min_minutes',
            'promised_delivery_max_minutes',
            'is_accepting_orders'
        ];
        
        // If it's an editable field for supervisors, allow editing
        if (editableFields.includes(fieldName)) {
            return false; // Not disabled
        }
        
        // All other fields are disabled for supervisors
        return true;
    };

    const isStallFieldDisabledForSupervisor = (fieldName) => {
        if (user_role !== 'supervisor') return stallForm.isViewOnly;
        
        // Supervisors can edit all fields in stall management popup
        const editableStallFields = [
            'hub',
            'stall_name',
            'pincode',
            'stall_address',
            'icon_url',
            'latitude',
            'longitude',
            'is_active'
        ];
        
        if (editableStallFields.includes(fieldName)) {
            return false; 
        }
        return true;
    };
    
    const [formData, setFormData] = useState([]);
    const [inventoryform, setInventoryForm] = useState(inventoryForm);
    const [stallform, setStallForm] = useState(stallForm);
    const [loading, setLoading] = useState(false)
    const [errors, setErrors] = useState({});
    const [stallErrors, setStallErrors] = useState({});
    const [instock, setInstock] = useState([])
    const [lowStock, setLowstock] = useState([])
    const [outOfStock, setOutOfStock] = useState([])
    
    const GetProducts = useGetProducts()
    const getInventeroryDetails = useGetInventoryDetails()
    const getInventerory = useGetInventory()

    const inputStyles = {
        backgroundColor: "white",
        height: "32px",
        borderRadius: "2px",
        border: "1px solid",
        borderColor: "secondary.border",
        padding: "5px 12px",
        fontSize: "14px",
        color: "black"
    };

    const navigate = useNavigate()
    useEffect(() => {
        //console.log(inventoryForm)
        if (inventoryDetails) {
            setFormData(inventoryDetails)
        }
        if (inventoryForm) {
            setInventoryForm(inventoryForm)
        }
        if (stallForm) {
            setStallForm(stallForm)
        }

        dispatch(updateUpdatedDate(null))
    }, [inventoryDetails, inventoryForm, stallForm])

    // Separate useEffect for fetching franchises only once
    useEffect(() => {
        fetchFranchises()
    }, [])

    const fetchFranchises = async () => {
        try {
            const response = await CustomAxios.get('/franchise/');
            dispatch(updateFranchises(response.data));
        } catch (error) {
            console.error('Error fetching franchises:', error);
        }
    };

    const refreshStallData = async () => {
        try {
            const response = await CustomAxios.get('stalls/?include_inactive=true');
            dispatch(updateStalls(response.data));
        } catch (error) {
            console.error('Error refreshing stall data:', error);
        }
    };
    const dispatch = useDispatch()
    const handleOpen = () => {
        dispatch(updateInventoryDetail({
            batch: [{
                product_id: "",
                available_units: "",
                units: "",
                total_units: "",
                expired_on: null,
                expire_alert: null,
                bogo_enabled: false,
                quantity: "",
            }
            ],
            place: "",
            supervisor_ids: [
                0
            ],
            admin_ids: [],
            customer_engagement_admin_ids: [],
            cashier_ids: [],
            details_id: '',
            purchased_on: null,
            supplier: '',
            invoice: '',
            batch_no: '',
        }));
        dispatch(updateinventoryDetailsEdit(false));
        dispatch(updateInventryHubsupervisors([]))
        dispatch(updateInventoryDetailsModal(true))
        setErrors({})
    };

    const handleOpenInventoryModal = () => {
        getDetails();
        
        dispatch(updateInventoryform({
            place: '',
            supervisor_ids: [],
            admin_ids: [],
            customer_engagement_admin_ids: [],
            cashier_ids: [],
            hub_setup: '',
            pincodes: [
                {
                    pincode: '',
                    latitude: '',
                    longitude: '',
                    hub_address: '',
                    inner_radius: '',
                    outter_radius: '',
                    radius_increase_delivery_fee: '',
                    north_latitude: '',
                    north_longitude: '',
                    south_latitude: '',
                    south_longitude: '',
                    east_latitude: '',
                    east_longitude: '',
                    west_latitude: '',
                    west_longitude: ''
                }
            ],
            delivery_fee: '',
            self_pickup_waiver: false,
            self_pickup_waiver_percentage: '',
            delivery_status : '',
            delivery_mini_spent: '',
            shop_open_at: null,
            shop_close_at: null,
            promised_delivery_min_minutes: '',
            promised_delivery_max_minutes: '',
            is_accepting_orders: true,
            cashier_ids: [],
            signup_offer_status: false,
            isViewOnly: false
        }));
        dispatch(updateinventoryEdit(false));
        dispatch(updateInventoryModal(true))
        setErrors({})

    };
    const handleCloseInventoryModal = () => {
        dispatch(updateInventoryform({
            place: '',
            supervisor_ids: [],
            admin_ids: [],
            customer_engagement_admin_ids: [],
            cashier_ids: [],
            hub_setup: '',
            pincodes: [
                {
                    pincode: '',
                    latitude: '',
                    longitude: '',
                    hub_address: '',
                    inner_radius: '',
                    outter_radius: '',
                    radius_increase_delivery_fee: '',
                    north_latitude: '',
                    north_longitude: '',
                    south_latitude: '',
                    south_longitude: '',
                    east_latitude: '',
                    east_longitude: '',
                    west_latitude: '',
                    west_longitude: ''
                }
            ],
            delivery_fee: '',
            self_pickup_waiver: false,
            self_pickup_waiver_percentage: '',
            delivery_status : '',
            delivery_mini_spent: '',
            shop_open_at: null,
            shop_close_at: null,
            promised_delivery_min_minutes: '',
            promised_delivery_max_minutes: '',
            is_accepting_orders: true,
            signup_offer_status: false,
            isViewOnly: false
        }));
        dispatch(updateinventoryEdit(false));
        dispatch(updateInventoryModal(false))
        setErrors({})

    };

    // Stall handlers
    const handleOpenStallModal = () => {
        dispatch(updateStallForm({
            hub: '',
            stall_name: '',
            pincode: '',
            latitude: '',
            longitude: '',
            stall_address: '',
            icon_url: '',
            is_active: true
        }));
        dispatch(updateStallEdit(false));
        dispatch(updateStallModal(true));
        setStallErrors({}); // Clear stall errors when opening modal
    };

    const handleCloseStallModal = () => {
        dispatch(resetStallForm());
        dispatch(updateStallEdit(false));
        dispatch(updateStallModal(false));
        setStallErrors({}); // Clear stall errors when closing modal
    };

    const handleChangeStall = (e) => {
        const { name, value } = e.target;
        const updatedForm = {
            ...stallform,
            [name]: value
        };
        setStallForm(updatedForm);
        dispatch(updateStallForm(updatedForm));
    };

    const handleStallSwitchChange = (e) => {
        const updatedForm = {
            ...stallform,
            is_active: e.target.checked
        };
        setStallForm(updatedForm);
        dispatch(updateStallForm(updatedForm));
    };

    const validationSchemaStall = Yup.object().shape({
        hub: Yup.string().required('Hub is required'),
        stall_name: Yup.string().required('Stall name is required'),
        pincode: Yup.string()
            .matches(/^\d{6}$/, 'Pincode must be exactly 6 digits')
            .required('Pincode is required'),
        latitude: Yup.number()
            .min(-90, 'Latitude must be between -90 and 90')
            .max(90, 'Latitude must be between -90 and 90')
            .nullable(),
        longitude: Yup.number()
            .min(-180, 'Longitude must be between -180 and 180')
            .max(180, 'Longitude must be between -180 and 180')
            .nullable(),
        stall_address: Yup.string().required('Stall address is required'),
        icon_url: Yup.string().url('Must be a valid URL').nullable(),
    });

    const handleSaveStall = async () => {
        try {
            setLoading(true);
            setStallErrors({}); // Clear previous errors
            await validationSchemaStall.validate(stallform, { abortEarly: false });
            
            const response = await CustomAxios.post(`stalls/create/`, stallform, {
                headers: {
                    'Content-Type': 'application/json',
                }
            });
            
            if (response.status === 201) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: 'Stall Created Successfully', life: 3000 });
                
                // Reset form and close modal
                dispatch(resetStallForm());
                dispatch(updateStallModal(false));
                dispatch(updateStallEdit(false));
                
                // Refresh data with a small delay to ensure backend is updated
                setTimeout(() => {
                    refreshStallData();
                }, 500);
                setLoading(false);
            }
        } catch (error) {
            if (error.name === 'ValidationError') {
                const validationErrors = {};
                error.inner.forEach((err) => {
                    validationErrors[err.path] = err.message;
                });
                setStallErrors(validationErrors);
            } else {
                console.error('Error creating stall:', error);
                // Handle server-side validation errors
                if (error?.response?.data) {
                    const serverErrors = error.response.data;
                    const formErrors = {};
                    
                    // Map server errors to form field names
                    Object.keys(serverErrors).forEach(key => {
                        if (Array.isArray(serverErrors[key]) && serverErrors[key].length > 0) {
                            formErrors[key] = serverErrors[key][0]; // Take first error message
                        } else if (typeof serverErrors[key] === 'string') {
                            formErrors[key] = serverErrors[key];
                        }
                    });
                    
                    setStallErrors(formErrors);
                } else {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to create stall', life: 3000 });
                }
            }
            setLoading(false);
        }
    };

    const handleEditStall = async (id) => {
        try {
            setLoading(true);
            setStallErrors({}); // Clear previous errors
            await validationSchemaStall.validate(stallform, { abortEarly: false });
            
            const response = await CustomAxios.put(`stalls/update/${id}/`, stallform, {
                headers: {
                    'Content-Type': 'application/json',
                }
            });
            
            if (response.status === 200) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: 'Stall Updated Successfully', life: 3000 });
                
                // Reset form and close modal
                dispatch(resetStallForm());
                dispatch(updateStallModal(false));
                dispatch(updateStallEdit(false));
                
                // Refresh data with a small delay to ensure backend is updated
                setTimeout(() => {
                    // Refresh stall data by calling the API directly
                    refreshStallData();
                }, 500);
                setLoading(false);
            }
        } catch (error) {
            if (error.name === 'ValidationError') {
                const validationErrors = {};
                error.inner.forEach((err) => {
                    validationErrors[err.path] = err.message;
                });
                setStallErrors(validationErrors);
            } else {
                console.error('Error updating stall:', error);
                // Handle server-side validation errors
                if (error?.response?.data) {
                    const serverErrors = error.response.data;
                    const formErrors = {};
                    
                    // Map server errors to form field names
                    Object.keys(serverErrors).forEach(key => {
                        if (Array.isArray(serverErrors[key]) && serverErrors[key].length > 0) {
                            formErrors[key] = serverErrors[key][0]; // Take first error message
                        } else if (typeof serverErrors[key] === 'string') {
                            formErrors[key] = serverErrors[key];
                        }
                    });
                    
                    setStallErrors(formErrors);
                } else {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to update stall', life: 3000 });
                }
            }
            setLoading(false);
        }
    };

    const handleHubChange = (e) => {
        const hubId = e.value;
        dispatch(updateSelectedHub(hubId));
        localStorage.setItem('selected_hub', hubId);
        // Refresh inventory details when hub changes
        getInventeroryDetails();
    };

    // const calculateTotalUnits = (updatedData) => {
    //     //console.log(updatedData)
    //     const total = updatedData.total_units_value + ' '+updatedData.units;
    //     setFormData((prevData) => ({
    //       ...prevData,
    //       total_units: total,
    //     }));
    //   };

    const handleChangeInventory = (e) => {
        // Handle both regular input events and PrimeReact dropdown events
        const name = e.target?.name || e.originalEvent?.target?.name;
        const value = e.target?.value !== undefined ? e.target.value : e.value;
        
        //console.log("handleChangeInventory - name:", name, "value:", value);
        
        let newNames = [];

        // If the name is for supervisors, get the corresponding names
        if (name === 'supervisor_ids') {
            newNames = value.map(id => {
                const supervisor = supervisors.find(s => s.value === id);  // Find the supervisor by ID
                return supervisor ? supervisor.name : '';  // Get the name or an empty string if not found
            });
            setInventoryForm((prevData) => ({
                ...prevData,
                [name]: value,
                names: newNames,
                supervisors: value
            }));
            dispatch(updateInventoryform({
                ...inventoryform,
                [name]: value,
                names: newNames,
                supervisors: value
            }));
        } else if (name === 'admin_ids') {
            // Handle admin_ids similar to supervisor_ids
            newNames = value.map(id => {
                const admin = admins.find(a => a.value === id);  // Find the admin by ID
                return admin ? admin.name : '';  // Get the name or an empty string if not found
            });
            setInventoryForm((prevData) => ({
                ...prevData,
                [name]: value,
                names: newNames,
                admins: value
            }));
            dispatch(updateInventoryform({
                ...inventoryform,
                [name]: value,
                names: newNames,
                admins: value
            }));
        } else if (name === 'customer_engagement_admin_ids') {
            // Handle customer_engagement_admin_ids similar to admin_ids
            newNames = value.map(id => {
                const customerEngagementAdmin = customerEngagementAdmins.find(a => a.value === id);  // Find the customer engagement admin by ID
                return customerEngagementAdmin ? customerEngagementAdmin.name : '';  // Get the name or an empty string if not found
            });
            setInventoryForm((prevData) => ({
                ...prevData,
                [name]: value,
                names: newNames,
                customerEngagementAdmins: value
            }));
            dispatch(updateInventoryform({
                ...inventoryform,
                [name]: value,
                names: newNames,
                customerEngagementAdmins: value
            }));
        }  else if (name === 'cashier_ids') {
            newNames = value.map(id => {
                const cashier = cashiers.find(a => a.value === id);
                return cashier ? cashier.name : '';
            });
            setInventoryForm((prevData) => ({
                ...prevData,
                [name]: value,
                cashier_ids: value,
                cashierNames: newNames
            }));
            dispatch(updateInventoryform({
                ...inventoryform,
                [name]: value,
                cashierNames: newNames
            }));
        } else if (name === 'franchise_id') {
            // When FoodFix franchise (id 2) is selected, clear hub-related fields
            const cleanedPincodes = (inventoryform.pincodes || []).map((p) => ({
                ...p,
                inner_radius: '',
                outter_radius: '',
                radius_increase_delivery_fee: '',
                north_latitude: '',
                north_longitude: '',
                south_latitude: '',
                south_longitude: '',
                east_latitude: '',
                east_longitude: '',
                west_latitude: '',
                west_longitude: ''
            }));
            const updated = {
                ...inventoryform,
                franchise_id: value,
                hub_setup: value === 2 ? '' : inventoryform.hub_setup,
                pincodes: value === 2 ? cleanedPincodes : inventoryform.pincodes
            };
            setInventoryForm(updated);
            dispatch(updateInventoryform(updated));
        } else {
            console.log("=====================name", name, "value", value);
            setInventoryForm((prevData) => ({
                ...prevData,
                [name]: value,
                names: newNames,
                supervisors: prevData.supervisor_ids
            }));
            dispatch(updateInventoryform({
                ...inventoryform,
                [name]: value
            }));
        }



    };



    // const getDetails = async () => {
    //     const users = await CustomAxios.get(`get_users/`, {
    //     }).then(res => {
    //         const options = res?.data?.users
    //             .filter((item) => item.role === 'supervisor')
    //             .map((item) => ({
    //                 name: `${item.first_name} ${item.last_name}`,
    //                 value: item.id
    //             }));
    //         dispatch(updateInventrySupervisors(options))
    //     })

    // }
    const getDetails = async () => {
        const users = await CustomAxios.get(`get_users/`, {
        }).then(res => {
            if (user_role === 'super_admin') {
                // Super Admin can assign Admin, Supervisor, and Customer Engagement Admin users - separate lists
                const adminOptions = res?.data?.users
                    .filter((item) => item.role === 'admin')
                    .map((item) => ({
                        name: `${item.first_name} ${item.last_name}`,
                        value: item.id
                    }));
                
                const supervisorOptions = res?.data?.users
                    .filter((item) => item.role === 'supervisor')
                    .map((item) => ({
                        name: `${item.first_name} ${item.last_name}`,
                        value: item.id
                    }));
                
                const customerEngagementAdminOptions = res?.data?.users
                    .filter((item) => item.role === 'customer_engagement_admin')
                    .map((item) => ({
                        name: `${item.first_name} ${item.last_name}`,
                        value: item.id
                    }));
                const cashierOptions = res?.data?.users
                    .filter((item) => item.role === 'cashier')
                    .map((item) => ({
                        name: `${item.first_name} ${item.last_name}`,
                        value: item.id
                    }));
                dispatch(updateInventryAdmins(adminOptions || []));
                dispatch(updateInventrySupervisors(supervisorOptions || []));
                dispatch(updateInventryCustomerEngagementAdmins(customerEngagementAdminOptions || []));
                dispatch(updateInventryCashiers(cashierOptions || []));
            } else {
                // Other roles can only assign Supervisor users
                const supervisorOptions = res?.data?.users
                    .filter((item) => item.role === 'supervisor')
                    .map((item) => ({
                        name: `${item.first_name} ${item.last_name}`,
                        value: item.id
                    }));
                
                dispatch(updateInventryAdmins([])); // Empty for non-super-admin
                dispatch(updateInventrySupervisors(supervisorOptions || []));
                dispatch(updateInventryCustomerEngagementAdmins([])); // Empty for non-super-admin
                dispatch(updateInventryCashiers([]));
            }
        }).catch(err => {
            console.error("Error fetching users:", err);
        })
    }

    useEffect(() => {
        getInventerory()
        getDetails()
        GetProducts()
        // Don't call getInventeroryDetails() automatically - wait for hub selection
    }, [])


    const filteredHubOptions = useMemo(() => {
        const list = Array.isArray(inventory) ? inventory : [];
        return list.filter((hub) => hub?.franchise?.id === 2);
    }, [inventory])

    useEffect(() => {
        if (inventoryModal) {
            getDetails();
        }
    }, [inventoryModal])
    // Auto-select first hub if none is selected
    useEffect(() => {
        const currentSelectedHub = Array.isArray(selectedHub) ? selectedHub[0] : selectedHub;
        if (inventory && inventory.length > 0 && !currentSelectedHub) {
            const firstHub = inventory[0];
            dispatch(updateSelectedHub(firstHub.value));
            localStorage.setItem('selected_hub', firstHub.value);
        }
    }, [inventory, selectedHub, dispatch])

    //console.log(">>>>>>>>>>>>>>>>>>>", inventory)
    const handleSaveInventory = async () => {
        try {
            setLoading(true);
            await validationSchema.validate(inventoryform, { abortEarly: false, context: { user_role, hub_setup: inventoryform?.hub_setup, franchise_id: inventoryform?.franchise_id } });
            setErrors({});
            // Normalize payload for backend
            const mapHubSetupForBackend = (value) => {
                if (!value) return '';
                //if (value === 'radius_and_pincode') return 'radius';
                //if (value === 'boundary') return 'radius';
                return value;
            };
            const payload = {
                ...inventoryform,
                hub_setup: inventoryform?.franchise_id === 2 ? 'pincode' : mapHubSetupForBackend(inventoryform?.hub_setup),
            };
            await CustomAxios.post(`inventory/create/`, payload, {});
            toast.current.show({ severity: 'success', summary: 'Success', detail: 'Inventory Created Successfully', life: 3000 });
            getInventerory()
            dispatch(updateInventoryModal(false))
            setLoading(false);

        }
        catch (validationErrors) {
            if (validationErrors.name === "ValidationError") {
                const formErrors = {};
                validationErrors.inner.forEach((error) => {
                    formErrors[error.path] = error.message;
                });
                setErrors(formErrors);
                setLoading(false);
            } else if (validationErrors?.response?.data) {
                const serverErrors = validationErrors.response.data;
                const formErrors = {};
                Object.keys(serverErrors).forEach(key => {
                    if (Array.isArray(serverErrors[key]) && serverErrors[key].length > 0) {
                        formErrors[key] = serverErrors[key][0];
                    } else if (typeof serverErrors[key] === 'string') {
                        formErrors[key] = serverErrors[key];
                    }
                });
                setErrors(formErrors);
                setLoading(false);
            } else {
                console.log('submit error', validationErrors)
                toast.current.show({ severity: 'error', summary: 'Error', detail: `Failed to create hub`, life: 3000 })
                setLoading(false);
            }
        }

    }






    const handleEditInventory = async (id) => {
        try {
            setLoading(true)
            await validationSchema.validate(inventoryform, { abortEarly: false, context: { user_role, hub_setup: inventoryform?.hub_setup, franchise_id: inventoryform?.franchise_id } });
            setErrors({});
            
            console.log("=== FRONTEND DEBUG ===");
            console.log("Sending inventoryform (pre-normalize):", inventoryform);
            console.log("supervisor_ids:", inventoryform.supervisor_ids);
            console.log("admin_ids:", inventoryform.admin_ids);
            console.log("=== END FRONTEND DEBUG ===");
            
            // Normalize payload for backend
            const mapHubSetupForBackend = (value) => {
                if (!value) return '';
                //if (value === 'radius_and_pincode') return 'radius';
                //if (value === 'boundary') return 'radius';
                return value;
            };
            const payload = {
                ...inventoryform,
                hub_setup: inventoryform?.franchise_id === 2 ? 'pincode' : mapHubSetupForBackend(inventoryform?.hub_setup),
            };
            console.log("Sending payload (normalized):", payload);
            await CustomAxios.put(`inventory/update/${id}/`, payload, {});
            toast.current.show({ severity: 'success', summary: 'Success', detail: 'Inventory Updated Successfully', life: 3000 });
            // Reset form and close modal
            dispatch(updateInventoryform({
            place: '',
            mobileno: '',
            supervisor_ids: [],
            admin_ids: [],
            customer_engagement_admin_ids: [],
            cashier_ids: [],
                    franchise_id: '',
                    hub_setup: '',
                    pincodes: [{ 
                        pincode: '', 
                        latitude: '', 
                        longitude: '', 
                        hub_address: '',
                        inner_radius: '',
                        outter_radius: '',
                        radius_increase_delivery_fee: '',
                        north_latitude: '',
                        north_longitude: '',
                        south_latitude: '',
                        south_longitude: '',
                        east_latitude: '',
                        east_longitude: '',
                        west_latitude: '',
                        west_longitude: ''
                    }],
                    delivery_fee: '',
                    self_pickup_waiver: false,
                    self_pickup_waiver_percentage: '',
                    delivery_status: '',
                    delivery_mini_spent: '',
                    shop_open_at: null,
                    shop_close_at: null,
                    promised_delivery_min_minutes: '',
                    promised_delivery_max_minutes: '',
                    is_accepting_orders: true,
                    signup_offer_status: false
            }));
            dispatch(updateInventoryModal(false));
            dispatch(updateinventoryEdit(false));
            // Refresh data with a small delay to ensure backend is updated
            setTimeout(() => {
                getInventeroryDetails();
                getInventerory();
            }, 500);
            setLoading(false);
        }
        catch (validationErrors) {
            if (validationErrors.name === "ValidationError") {
                const formErrors = {};
                validationErrors.inner.forEach((error) => {
                    formErrors[error.path] = error.message;
                });
                setErrors(formErrors);
                setLoading(false)
            } else if (validationErrors?.response?.data) {
                const serverErrors = validationErrors.response.data;
                const formErrors = {};
                Object.keys(serverErrors).forEach(key => {
                    if (Array.isArray(serverErrors[key]) && serverErrors[key].length > 0) {
                        formErrors[key] = serverErrors[key][0];
                    } else if (typeof serverErrors[key] === 'string') {
                        formErrors[key] = serverErrors[key];
                    }
                });
                setErrors(formErrors);
                /*
                 * Say it out loud as well as in the form.
                 *
                 * The server explains a 400 precisely -- "The following
                 * supervisor IDs are invalid: [1761, 2164]" -- and this only
                 * put it beside the field it belongs to. In a modal this long
                 * that lands off-screen, so the save looked like it silently
                 * did nothing and the reason had to be dug out of the server
                 * log. A toast cannot be scrolled past.
                 */
                toast.current.show({
                    severity: 'error',
                    summary: 'Could not update hub',
                    detail: describeServerErrors(serverErrors),
                    life: 8000,
                });
                setLoading(false)
            } else {
                console.log('submit error', validationErrors)
                toast.current.show({ severity: 'error', summary: 'Error', detail: `Failed to update hub`, life: 3000 })
                setLoading(false)
            }
        }
    }





    const validationSchema = Yup.object().shape({
        place: Yup.string()
            .required("place is required"),
        mobileno: Yup.string()
            .required('Mobile number is required')
            .matches(/^\d+$/, "Only numeric values are allowed for place"),
        supervisor_ids: Yup.array()
            .of(Yup.number().required('Each item must be a number'))
            .min(1, 'At least one supervisor is required')
            .required("At least one supervisor is required"),
        admin_ids: Yup.array()
            .of(Yup.number().required('Each item must be a number'))
            .when('$user_role', {
                is: 'super_admin',
                then: schema => schema.min(1, 'At least one admin is required').required('At least one admin is required'),
                otherwise: schema => schema.optional()
            }),
        customer_engagement_admin_ids: Yup.array()
            .of(Yup.number().required('Each item must be a number'))
            .when('$user_role', {
                is: 'super_admin',
                then: schema => schema.min(1, 'At least one customer engagement admin is required').required('At least one customer engagement admin is required'),
                otherwise: schema => schema.optional()
            }),
        delivery_fee:Yup.string().required("delivery fee is required"),
        delivery_status : Yup.string().required('Choose Delivery status'),
        delivery_mini_spent : Yup.number().required('Enter the Delivery Minimum Spent'),
        self_pickup_waiver: Yup.boolean().required(),

        self_pickup_waiver_percentage: Yup.string().when('self_pickup_waiver', {
            is: true,
            then: schema => schema
                .required("Offer percentage is required")
                .matches(/^\d+(\.\d{1,2})?$/, "Enter a valid number with up to 2 decimals"),
            otherwise: schema => schema.notRequired()
        }),
        promised_delivery_min_minutes: Yup.number()
            .transform((v, o) => (o === '' || o === null ? undefined : v))
            .typeError("Enter a number of minutes")
            .integer("Whole minutes only")
            .min(1, "Must be at least 1 minute")
            .max(1440, "That is longer than a day"),
        promised_delivery_max_minutes: Yup.number()
            .transform((v, o) => (o === '' || o === null ? undefined : v))
            .typeError("Enter a number of minutes")
            .integer("Whole minutes only")
            .min(1, "Must be at least 1 minute")
            .max(1440, "That is longer than a day")
            .test(
                'not-before-from',
                'Must not be smaller than the From value',
                function (value) {
                    const from = this.parent.promised_delivery_min_minutes;
                    if (value === undefined || from === undefined || from === '' ) return true;
                    return Number(value) >= Number(from);
                }
            ),
        shop_open_at: Yup.string()
            .required("Opening time is required"),
        shop_close_at: Yup.string()
            .required("closing time is required"),
        pincodes: Yup.array().min(1, 'At least one pincode entry is required')
    });

    const validationSchemaInventoryDetails = Yup.object().shape({
        total_units: Yup.string()
            .matches(/^\d+(\.\d{1,2})?$/, "Price must contain only digits")
            .required("Total units is required"),
        product_id: Yup.string()
            .matches(/^\d+(\.\d{1,2})?$/, "Price must contain only digits")
            .required("product is required"),
        details_id: Yup.string()
            .matches(/^\d+(\.\d{1,2})?$/, "Price must contain only digits")
            .required("hub name is required"),
        available_units: Yup.string()
            .matches(/^\d+(\.\d{1,2})?$/, "Price must contain only digits")
            .required("Available units is required"),
        units: Yup.string()
            .required("units is required"),
    });
    console.log(formData)

    useEffect(() => {
        // Edge case: ensure array
        if (!Array.isArray(allinventoryDetails) || allinventoryDetails.length === 0) {
            setInstock([]);
            setLowstock([]);
            setOutOfStock([]);
            return;
        }

        // Parse numeric values safely (supports "10.45" and 10.45)
        const toUnits = (v) => {
            const n = Number(v);
            return Number.isFinite(n) && n >= 0 ? n : null;
        };

        try {
            // Categorize *rows* based on Capacity In Stock (available_units)
            // Rule: 0 = out of stock, 0 < units <= 20 = low stock, units > 20 = in stock
            const categorizedStock = allinventoryDetails.reduce((acc, inventory) => {
                const units = toUnits(inventory?.available_units);

                if (units === null) {
                    // Unknown/invalid units: don't count it toward stock buckets (prevents false low-stock)
                    return acc;
                }

                if (units === 0) acc.outofstock.push(inventory);
                else if (units <= 5) acc.lowstock.push(inventory);
                else acc.instock.push(inventory);

                return acc;
            }, { instock: [], lowstock: [], outofstock: [] });

            setInstock(categorizedStock.instock);
            setLowstock(categorizedStock.lowstock);
            setOutOfStock(categorizedStock.outofstock);
        } catch (error) {
            console.error('Error processing inventory data:', error);
            setInstock([]);
            setLowstock([]);
            setOutOfStock([]);

            if (toast.current) {
                toast.current.show({
                    severity: 'error',
                    summary: 'Data Error',
                    detail: 'Unable to process inventory data. Please refresh the page.',
                    life: 5000
                });
            }
        }
    }, [allinventoryDetails])

    const handleRemoveItem = (index) => {
        const updatedPin = inventoryform.pincodes.filter((_, i) => i !== index);
        setInventoryForm({ ...inventoryform, pincodes: updatedPin });
    };
    const handlePincodeChange = (e, index) => {
        const { name, value } = e.target;
        const updated = [...inventoryform.pincodes];

        // Merge the existing object with the new value
        updated[index] = {
            ...updated[index],
            [name]: value
        };

        setInventoryForm({ ...inventoryform, pincodes: updated });
    };
    const availability = [
        { name: 'Active', value: true },
        { name: 'Inactive', value: false },
    ];

    const handleAddPincode = () => {
        setInventoryForm({ 
            ...inventoryform, 
            pincodes: [
                ...inventoryform.pincodes, 
                {
                    pincode: '',
                    latitude: '',
                    longitude: '',
                    hub_address: '',
                    inner_radius: '',
                    outter_radius: '',
                    radius_increase_delivery_fee: '',
                    north_latitude: '',
                    north_longitude: '',
                    south_latitude: '',
                    south_longitude: '',
                    east_latitude: '',
                    east_longitude: '',
                    west_latitude: '',
                    west_longitude: ''
                }
            ] 
        });
    };
    
    // Check if user can manage inventory - AFTER all hooks
    if (!canViewInventory) {
        return (
            <Box sx={{ display: "flex", flexDirection: "column", gap: "20px", padding: "20px" }}>
                <Typography variant="h6" color="error">
                    Access Denied
                </Typography>
                <Typography>
                    You don't have permission to view inventory details. You can only send push notifications.
                </Typography>
            </Box>
        );
    }
    
    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: "20px", width: "100%", padding: "30px" }}>
            <Toast ref={toast} />
            {/* <ConfirmDialog /> */}
            <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                <Typography sx={{ fontSize: "16px", fontWeight: "700", lineHeight: "24px" }}>Product Management</Typography>
                <Typography sx={{ fontSize: "14px", fontWeight: "500", lineHeight: "22px" }}>Inventory</Typography>
            </Box>
            <Box sx={{ height: "94px", width: "100%", backgroundColor: "white", display: "flex", alignItems: { sm: "center", md: "center" } }}>
                <Box sx={{ width: "100%" }}>
                    <Typography sx={{ fontSize: { sm: "24px", md: "24px" }, fontWeight: "500", lineHeight: "32px", textAlign: "center" }}>{allinventoryDetails?.length}</Typography>
                    <Typography sx={{ fontSize: { sm: "14px", md: "14px" }, fontWeight: "400", lineHeight: "22px", textAlign: "center" }}>Total product</Typography>
                </Box>
                <Box sx={{ width: "100%" }}>
                    <Typography sx={{ fontSize: { sm: "24px", md: "24px" }, fontWeight: "500", lineHeight: "32px", textAlign: "center" }}>{instock?.length}</Typography>
                    <Typography sx={{ fontSize: { sm: "14px", md: "14px" }, fontWeight: "400", lineHeight: "22px", textAlign: "center" }}>In stock</Typography>
                </Box>
                <Box sx={{ width: "100%"}} >
                    <Typography sx={{fontSize: { sm: "24px", md: "24px" },fontWeight: "500",lineHeight: "32px",textAlign: "center",color: "#dc3545",}}>{lowStock?.length}</Typography>
                    <Typography sx={{fontSize: { sm: "14px", md: "14px" },fontWeight: "400",lineHeight: "22px",textAlign: "center",color: "#dc3545",fontWeight: "600"}}>Low stock</Typography>
                </Box>
                <Box sx={{ width: "100%" }}>
                    <Typography sx={{ fontSize: { sm: "24px", md: "24px" }, fontWeight: "500", lineHeight: "32px", textAlign: "center" }}>{outOfStock?.length}</Typography>
                    <Typography sx={{ fontSize: { sm: "14px", md: "14px" }, fontWeight: "400", lineHeight: "22px", textAlign: "center" }}>Out of stock</Typography>
                </Box>
            </Box>
            <Box sx={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                <Box sx={{ position: "relative" }}>
                    <InputBase sx={{ backgroundColor: "white", height: "32px", width: "100%", maxWidth: "268px", borderRadius: "2px", border: "1px solid", borderColor: "secondary.border", padding: "5px 12px 5px 40px", fontSize: "14px", fontWeight: "400", lineHeight: "22px", color: "black" }} onChange={(e) => dispatch(updateInventorySearchProduct(e.target.value))} placeholder="Search item name" />
                    <SearchIcon sx={{ position: "absolute", left: "12px", top: "5px", width: "20px", height: "20px" }} />
                </Box>
                <Box sx={{ display: "flex", gap: "20px" }}>
                    {user_role === 'super_admin' && <Button variant="contained" onClick={handleOpenInventoryModal} sx={{ textTransform: "none" }}><Typography sx={{ fontSize: { sm: "12px", md: "14px" }, fontWeight: "400", lineHeight: "22px", textAlign: "center" }}>Add Hub</Typography> </Button>}
                    {(user_role === 'super_admin' || user_role === 'admin' || user_role === 'supervisor') && <Button variant="contained" onClick={handleOpenStallModal} sx={{ textTransform: "none", backgroundColor: "#ff9800" }}><Typography sx={{ fontSize: { sm: "12px", md: "14px" }, fontWeight: "400", lineHeight: "22px", textAlign: "center" }}>Add Stall</Typography> </Button>}
                    {user_role === 'super_admin' && <Button variant="contained" onClick={() => navigate("/home/franchise")} sx={{ textTransform: "none", backgroundColor: "#4caf50" }}><Typography sx={{ fontSize: { sm: "12px", md: "14px" }, fontWeight: "400", lineHeight: "22px", textAlign: "center" }}>Manage Franchises</Typography> </Button>}
                    {canManageInventory && <Button variant="contained" onClick={handleOpen} sx={{ textTransform: "none", backgroundColor: "button.blue", border: "none" }}> <Typography sx={{ fontSize: { sm: "12px", md: "14px" }, fontWeight: "400", lineHeight: "22px", textAlign: "center" }}>Add Batch</Typography></Button>}
                    <Button variant="outlined" sx={{ border: "1px solid", borderColor: "secondary.border", textTransform: "none", backgroundColor: "white" }} onClick={() => (navigate("/home/BatchHistory"), dispatch(updatepageName('BatchHistory')))}> <Typography sx={{ color: "black", fontSize: { sm: "12px", md: "14px" }, fontWeight: "400", lineHeight: "22px", textAlign: "center" }}>Batch History</Typography></Button>
                </Box>
            </Box>
            {(user_role === 'admin' || user_role === 'super_admin' || user_role === 'supervisor') && <InventoryTable />}
            {(user_role === 'admin' || user_role === 'super_admin' || user_role === 'supervisor') && <StallTable />}
            
            {/* Hub Selection for Inventory Details */}
            {user_role !== 'supervisor' && (
                <Box sx={{ backgroundColor: "white", borderRadius: "8px", padding: "24px", marginTop: "20px" }}>
                    <Typography sx={{ fontSize: "16px", fontWeight: "700", lineHeight: "24px", marginBottom: "20px" }}>
                        Select Hub for Inventory Details
                    </Typography>
                    <Box sx={{ display: "flex", gap: "16px", alignItems: "center" }}>
                        <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>Hub:</Typography>
                        <Dropdown 
                            value={Array.isArray(selectedHub) ? selectedHub[0] : selectedHub} 
                            options={(() => {
                                if (user_role === 'super_admin') {
                                    return inventory || [];
                                } else if (user_role === 'customer_engagement_admin') {
                                    // For customer engagement admin, only show assigned hubs
                                    const assignedHubs = JSON.parse(localStorage.getItem('hub') || '[]');
                                    return (inventory || []).filter(hub => {
                                        return assignedHubs.includes(hub.value);
                                    });
                                } else {
                                    // For admin and other roles, show assigned hubs
                                    const assignedHubs = JSON.parse(localStorage.getItem('hub') || '[]');
                                    return (inventory || []).filter(hub => {
                                        return assignedHubs.includes(hub.value);
                                    });
                                }
                            })()} 
                            onChange={handleHubChange}
                            optionLabel="name" 
                            optionValue="value"
                            placeholder="Select a hub to view inventory details"
                            style={{ minWidth: "300px" }}
                        />
                    </Box>
                    {user_role !== 'super_admin' && (
                        <Typography sx={{ fontSize: "12px", color: "gray", fontStyle: "italic", marginTop: "8px" }}>
                            Showing only hubs assigned to you
                        </Typography>
                    )}
                </Box>
            )}
            
            {/* Supervisor Information */}
            {user_role === 'supervisor' && (
                <Box sx={{ backgroundColor: "white", borderRadius: "8px", padding: "24px", marginTop: "20px" }}>
                    <Typography sx={{ fontSize: "16px", fontWeight: "700", lineHeight: "24px", marginBottom: "10px" }}>
                        Inventory Details
                    </Typography>
                    <Typography sx={{ fontSize: "14px", color: "gray", fontStyle: "italic" }}>
                        Showing inventory details for all hubs where you are assigned as supervisor
                    </Typography>
                </Box>
            )}
            
            <InventoryDetailsTable />
            <OrderDetailsModal />
            <Modal
                open={inventoryModal}
                onClose={handleCloseInventoryModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                sx={{ zIndex: 1000 }}
            >
                <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: '100%', maxWidth: "900px", height: "80vh", backgroundColor: 'white', }}>

                    <Box sx={{ height: "46px important", padding: "12px 24px", backgroundColor: "#EEEEEE", display: "flex", alignItems: "center" }}>
                        <Typography sx={{ fontSize: "14", fontWeight: "500", lineHeight: "22px" }}>
                            {inventoryform.isViewOnly ? 'View Hub' : (InventoryEdit ? 'Edit Hub' : 'Add Hub')}
                        </Typography>
                    </Box>
                    <Box sx={{ display: "flex", flexDirection: "column", gap: "16px", padding: "30px", height: 'calc(80vh - 120px)', overflow: 'auto' }}>
                        <Box sx={{ display: "flex", gap: "16px" }}>
                            <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }}>Hub Name</Typography>
                                <InputBase value={inventoryform.place} disabled={isFieldDisabledForSupervisor('place')} sx={{ backgroundColor: "white", width: "100%", height: "32px", borderRadius: "2px", border: "1px solid", borderColor: "secondary.border", padding: "5px 12px", fontSize: "14px", fontWeight: "400", lineHeight: "22px", color: "black" }} placeholder="Enter hub name" name="place" onChange={handleChangeInventory} />
                                {errors.place && <Typography style={{ color: "red", fontSize: "12PX", fontWeight: "400", lineHeight: "22px" }}>{errors.place}</Typography>}
                            </Box>
                            <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }}>Franchise</Typography>
                                <Dropdown 
                                    onChange={handleChangeInventory} 
                                    value={inventoryform.franchise_id} 
                                    options={franchises} 
                                    name="franchise_id" 
                                    optionLabel="name" 
                                    optionValue="id"
                                    style={{ zIndex: "1000" }}
                                    placeholder="Select franchise" 
                                    className="w-full md:w-20rem" 
                                    disabled={isFieldDisabledForSupervisor('franchise_id')}
                                />
                                {errors.franchise_id && <Typography style={{ color: "red", fontSize: "12PX", fontWeight: "400", lineHeight: "22px" }}>{errors.franchise_id}</Typography>}
                            </Box>
                        </Box>
                        {inventoryform?.franchise_id !== 2 && (
                            <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }}>Hub Setup</Typography>
                                {console.log("RENDERING HUB SETUP DROPDOWN - Current value:", inventoryform.hub_setup)}
                                <Dropdown 
                                    onChange={(e) => {
                                        console.log("Hub Setup Dropdown onChange - e.value:", e.value);
                                        handleChangeInventory({
                                            target: { name: 'hub_setup', value: e.value }
                                        });
                                    }} 
                                    value={inventoryform.hub_setup} 
                                    options={[
                                        { label: 'Pincode', value: 'pincode' },
                                        { label: 'Radius', value: 'radius' },
                                        { label: 'Radius & Pincode', value: 'radius_and_pincode' },
                                        { label: 'Boundary', value: 'boundary' }
                                    ]} 
                                    name="hub_setup" 
                                    optionLabel="label" 
                                    optionValue="value"
                                    style={{ zIndex: "1000" }}
                                    placeholder="Select hub setup type" 
                                    className="w-full md:w-20rem" 
                                    disabled={isFieldDisabledForSupervisor('hub_setup')}
                                />
                                {errors.hub_setup && <Typography style={{ color: "red", fontSize: "12PX", fontWeight: "400", lineHeight: "22px" }}>{errors.hub_setup}</Typography>}
                            </Box>
                        )}
                        <Box sx={{ display: "flex", gap: "16px" }}>
                            <Box sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }} >Supervisors</Typography>
                                <MultiSelect onChange={handleChangeInventory} value={inventoryform.supervisor_ids} options={supervisors} name="supervisor_ids" optionLabel="name" style={{ zIndex: "1000" }}
                                    placeholder="Select supervisor" className="w-full md:w-20rem" disabled={isFieldDisabledForSupervisor('supervisor_ids')} />
                                {errors.supervisor_ids && <Typography style={{ color: "red", fontSize: "12PX", fontWeight: "400", lineHeight: "22px" }}>{errors.supervisor_ids}</Typography>}
                            </Box>
                            {user_role === 'super_admin' && (
                                <Box sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                    <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }} >Admins</Typography>
                                    <MultiSelect onChange={handleChangeInventory} value={inventoryform.admin_ids} options={admins} name="admin_ids" optionLabel="name" style={{ zIndex: "1000" }}
                                        placeholder="Select admin" className="w-full md:w-20rem" disabled={isFieldDisabledForSupervisor('admin_ids')} />
                                    {errors.admin_ids && <Typography style={{ color: "red", fontSize: "12PX", fontWeight: "400", lineHeight: "22px" }}>{errors.admin_ids}</Typography>}
                                </Box>
                            )}
                            {user_role === 'super_admin' && (
                                <Box sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                    <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }} >Customer Engagement Admins</Typography>
                                    <MultiSelect onChange={handleChangeInventory} value={inventoryform.customer_engagement_admin_ids} options={customerEngagementAdmins} name="customer_engagement_admin_ids" optionLabel="name" style={{ zIndex: "1000" }}
                                        placeholder="Select customer engagement admin" className="w-full md:w-20rem" disabled={isFieldDisabledForSupervisor('customer_engagement_admin_ids')} />
                                    {errors.customer_engagement_admin_ids && <Typography style={{ color: "red", fontSize: "12PX", fontWeight: "400", lineHeight: "22px" }}>{errors.customer_engagement_admin_ids}</Typography>}
                                </Box>
                            )}

                            {user_role === 'super_admin' && (
                                <Box sx={{ display: "flex", flexDirection: "column", gap: "8px", width: "220px" }}>
                                    <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }} >Cashiers (Optional)</Typography>
                                    <MultiSelect
                                        onChange={handleChangeInventory}
                                        value={inventoryform.cashier_ids}
                                        options={cashiers}
                                        name="cashier_ids"
                                        optionLabel="name"
                                        style={{ zIndex: "1000" }}
                                        placeholder="Assign cashiers for order management hubs"
                                        className="w-full md:w-20rem"
                                        disabled={isFieldDisabledForSupervisor('cashier_ids')}
                                    />
                                    {errors.cashier_ids && <Typography style={{ color: "red", fontSize: "12PX", fontWeight: "400", lineHeight: "22px" }}>{errors.cashier_ids}</Typography>}
                                    <Typography sx={{ fontSize: "12PX", fontStyle: "italic", color: "text.secondary" }}>
                                        Only needed for hubs that use Order Management
                                    </Typography>
                                </Box>
                            )}
                             
                        </Box>
                        <Box sx={{ display: "flex", gap: "16px", width: "100%" }}> 

                        <Box sx={{ flex: 1, display: "flex", flexDirection: "column", gap: "8px", width: "105px" }}>
                                    <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px", flexWrap: "nowrap", whiteSpace: "nowrap" }}>Shop Opening Time</Typography>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <MobileTimePicker
                                            ampm={false}
                                            disabled={isFieldDisabledForSupervisor('shop_open_at')}
                                            value={inventoryform.shop_open_at ? dayjs(inventoryform.shop_open_at, 'HH:mm:ss') : null}
                                            onChange={(newValue) =>
                                                handleChangeInventory({
                                                    target: {
                                                        name: 'shop_open_at',
                                                        value: dayjs(newValue).format('HH:mm:ss'),
                                                    },
                                                })
                                            }
                                            slotProps={{
                                                textField: {
                                                    sx: {
                                                        height: '38px',
                                                        '& .MuiInputBase-root': {
                                                            height: '38px',
                                                            fontSize: '14px',
                                                            padding: '0 10px',
                                                        }
                                                    }
                                                }
                                            }}
                                        />
                                    </LocalizationProvider>
                                    <Typography sx={{ color: "red", fontSize: "12px", mt: "-6px" }}>
                                        {errors.shop_open_at}
                                    </Typography>
                                </Box>

                                <Box sx={{ flex: 1, display: "flex", flexDirection: "column", gap: "8px" }}>
                                    <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px", flexWrap: "nowrap", whiteSpace: "nowrap" }}>Shop Closing Time</Typography>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <MobileTimePicker
                                            ampm={false}
                                            disabled={isFieldDisabledForSupervisor('shop_close_at')}
                                            value={inventoryform.shop_close_at ? dayjs(inventoryform.shop_close_at, 'HH:mm:ss') : null}
                                            onChange={(newValue) =>
                                                handleChangeInventory({
                                        target: {
                                            name: 'shop_close_at',
                                            value: dayjs(newValue).format('HH:mm:ss'),
                                        },
                                        })
                                            }
                                            slotProps={{
                                                textField: {
                                                    sx: {
                                                        height: '38px',
                                                        '& .MuiInputBase-root': {
                                                            height: '38px',
                                                            fontSize: '14px',
                                                            padding: '0 10px',
                                                        }
                                                    }
                                                }
                                            }}
                                        />
                                    </LocalizationProvider>
                                        <Typography sx={{ color: "red", fontSize: "12px", mt: "-6px" }}>
                                            {errors.shop_close_at}
                                        </Typography>
                                </Box>
                        </Box>
                        {/*
                          The manual on/off switch for this hub. Not the same as
                          Delivery Status below (that is free-delivery pricing) and
                          not the same as the shop hours above (a daily schedule) —
                          this is "we are not taking orders right now" for any reason.
                        */}
                        <Box sx={{ display: "flex", gap: "16px", width: "100%" }}>
                            <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: "4px" }}>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={inventoryform.is_accepting_orders !== false}
                                            disabled={isFieldDisabledForSupervisor('is_accepting_orders')}
                                            onChange={(e) =>
                                                handleChangeInventory({
                                                    target: { name: 'is_accepting_orders', value: e.target.checked },
                                                })
                                            }
                                        />
                                    }
                                    label="Accepting orders"
                                />
                                <Typography sx={{ fontSize: "12px", color: "text.secondary", ml: "48px", mt: "-6px" }}>
                                    {inventoryform.is_accepting_orders === false
                                        ? "Customers can browse this hub but cannot add to cart or check out."
                                        : "This hub is taking orders normally."}
                                </Typography>
                            </Box>
                        </Box>

                        {/*
                          The delivery promise the customer sees on their order card
                          ("Est. Delivery 12-15 mins"). It is a promise this hub makes,
                          not a prediction — nothing in the system estimates per-order
                          delivery time. Leaving both blank hides that corner of the card
                          and the app shows elapsed time instead.
                        */}
                        <Box sx={{ display: "flex", gap: "16px", width: "100%" }}>
                            <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }}>Delivery Promise — From (mins)</Typography>
                                <InputBase type="number" min="1" max="1440" value={inventoryform.promised_delivery_min_minutes ?? ''} disabled={isFieldDisabledForSupervisor('promised_delivery_min_minutes')} sx={{ backgroundColor: "white", width: "100%", height: "32px", borderRadius: "2px", border: "1px solid", borderColor: "secondary.border", padding: "5px 12px", fontSize: "14px", fontWeight: "400", lineHeight: "22px", color: "black" }} placeholder="e.g. 12" name="promised_delivery_min_minutes" onChange={handleChangeInventory} />
                                {errors.promised_delivery_min_minutes && <Typography style={{ color: "red", fontSize: "12PX", fontWeight: "400", lineHeight: "22px" }}>{errors.promised_delivery_min_minutes}</Typography>}
                            </Box>
                            <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }}>Delivery Promise — To (mins)</Typography>
                                <InputBase type="number" min="1" max="1440" value={inventoryform.promised_delivery_max_minutes ?? ''} disabled={isFieldDisabledForSupervisor('promised_delivery_max_minutes')} sx={{ backgroundColor: "white", width: "100%", height: "32px", borderRadius: "2px", border: "1px solid", borderColor: "secondary.border", padding: "5px 12px", fontSize: "14px", fontWeight: "400", lineHeight: "22px", color: "black" }} placeholder="e.g. 15" name="promised_delivery_max_minutes" onChange={handleChangeInventory} />
                                {errors.promised_delivery_max_minutes && <Typography style={{ color: "red", fontSize: "12PX", fontWeight: "400", lineHeight: "22px" }}>{errors.promised_delivery_max_minutes}</Typography>}
                            </Box>
                            <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: "10px", justifyContent: "flex-end" }}>
                                <Typography sx={{ fontSize: "12PX", fontStyle: "italic", color: "text.secondary", pb: "6px" }}>
                                    Shown to customers as "Est. Delivery {inventoryform.promised_delivery_min_minutes && inventoryform.promised_delivery_max_minutes && String(inventoryform.promised_delivery_min_minutes) !== String(inventoryform.promised_delivery_max_minutes) ? `${inventoryform.promised_delivery_min_minutes}-${inventoryform.promised_delivery_max_minutes} mins` : (inventoryform.promised_delivery_min_minutes || inventoryform.promised_delivery_max_minutes) ? `${inventoryform.promised_delivery_min_minutes || inventoryform.promised_delivery_max_minutes} mins` : "—"}". Leave both blank to hide it.
                                </Typography>
                            </Box>
                        </Box>
                        <Box sx={{ display: "flex", gap: "16px", width: "100%" }}>
                            <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }}>Delivery Charge</Typography>
                                <InputBase type="number" step="0.01" min="0" value={inventoryform.delivery_fee} disabled={isFieldDisabledForSupervisor('delivery_fee')} sx={{ backgroundColor: "white", width: "100%", height: "32px", borderRadius: "2px", border: "1px solid", borderColor: "secondary.border", padding: "5px 12px", fontSize: "14px", fontWeight: "400", lineHeight: "22px", color: "black" }} placeholder="Enter Delivery Charge" name="delivery_fee" onChange={handleChangeInventory} />
                                {errors.delivery_fee && <Typography style={{ color: "red", fontSize: "12PX", fontWeight: "400", lineHeight: "22px" }}>{errors.delivery_fee}</Typography>}
                            </Box>
                            <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }}>Delivery Mini Spent</Typography>
                                <InputBase type="number" step="0.01" min="0" value={inventoryform.delivery_mini_spent} disabled={isFieldDisabledForSupervisor('delivery_mini_spent')} sx={{ backgroundColor: "white", width: "100%", height: "32px", borderRadius: "2px", border: "1px solid", borderColor: "secondary.border", padding: "5px 12px", fontSize: "14px", fontWeight: "400", lineHeight: "22px", color: "black" }} placeholder="Enter Delivey Minimum Spent" name="delivery_mini_spent" onChange={handleChangeInventory} />
                                {errors.delivery_mini_spent && <Typography style={{ color: "red", fontSize: "12PX", fontWeight: "400", lineHeight: "22px" }}>{errors.delivery_mini_spent}</Typography>}
                            </Box>
                              <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }} >Delivery Status</Typography>
                                <Dropdown onChange={handleChangeInventory} value={inventoryform.delivery_status} options={availability} name="delivery_status" optionLabel="name" style={{ zIndex: "1000" }}
                                    placeholder="Select Availablity" className="w-full md:w-20rem" disabled={isFieldDisabledForSupervisor('delivery_status')} />
                                    {errors.delivery_status && <Typography style={{ color: "red", fontSize: "12PX", fontWeight: "400", lineHeight: "22px" }}>{errors.delivery_status}</Typography>}

                            </Box>
                        </Box>
                          <Box sx={{ display: "flex", gap: "16px", width: "100%" }}>
                             <Box sx={{ display: "flex", flexDirection: "column", gap: "10px", width: "100%" }}>
                                <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }} >Self Pickup Offer</Typography>
                                <Dropdown onChange={handleChangeInventory} value={inventoryform.self_pickup_waiver} options={availability} name="self_pickup_waiver" optionLabel="name" style={{ zIndex: "1000" }}
                                    placeholder="Select Availablity" className="w-full md:w-20rem" disabled={isFieldDisabledForSupervisor('self_pickup_waiver')} />
                            </Box>
                            {inventoryform.self_pickup_waiver === true && <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }}>Offer %</Typography>
                                <InputBase type="number" step="0.01" value={inventoryform.self_pickup_waiver_percentage} disabled={isFieldDisabledForSupervisor('self_pickup_waiver_percentage')} sx={{ backgroundColor: "white", width: "100%", height: "32px", borderRadius: "2px", border: "1px solid", borderColor: "secondary.border", padding: "5px 12px", fontSize: "14px", fontWeight: "400", lineHeight: "22px", color: "black" }} placeholder="Enter Offer %" name="self_pickup_waiver_percentage" onChange={handleChangeInventory} />
                                {errors.self_pickup_waiver_percentage && <Typography style={{ color: "red", fontSize: "12PX", fontWeight: "400", lineHeight: "22px" }}>{errors.self_pickup_waiver_percentage}</Typography>}
                            </Box>}
                        </Box>

                        <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: "10px" }}>
                            <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }}>Mobile Number</Typography>
                            <InputBase
                                value={inventoryform.mobileno}
                                name="mobileno"
                                disabled={isFieldDisabledForSupervisor('mobileno')}
                                onChange={handleChangeInventory}
                                placeholder="Enter mobile number"
                                sx={inputStyles}
                            />
                            {errors.mobileno && (
                                <Typography style={{ color: "red", fontSize: "12PX", fontWeight: "400", lineHeight: "22px" }}>
                                    {errors.mobileno}
                                </Typography>
                            )}
                        </Box>

                        <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: "10px" }}>
                            <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }}>Signup Offer Status</Typography>
                                <Switch
                                    checked={inventoryform.signup_offer_status || false}
                                    onChange={(e) => handleChangeInventory({
                                        target: { name: 'signup_offer_status', value: e.target.checked }
                                    })}
                                    disabled={isFieldDisabledForSupervisor('signup_offer_status')}
                                    color="primary"
                                />
                            </Box>
                            {errors.signup_offer_status && (
                                <Typography style={{ color: "red", fontSize: "12PX", fontWeight: "400", lineHeight: "22px" }}>
                                    {errors.signup_offer_status}
                                </Typography>
                            )}
                        </Box>

                        <Typography sx={{ fontSize: "16PX", fontWeight: "600", lineHeight: "24px", mt: 2 }}>Pincode Details</Typography>
                        {inventoryform?.pincodes?.map((item, index) => (
                            <Box
                                key={index}
                                sx={{ border: "1px solid #e0e0e0", borderRadius: "4px", padding: "16px", mb: 2, position: "relative" }}
                            >
                                <Typography sx={{ fontSize: "14px", fontWeight: "600", mb: 2 }}>Location {index + 1}</Typography>
                                
                                {/* Basic Info Row (Pincode) - show for 'pincode' or 'radius_and_pincode', and ALWAYS for FoodFix (franchise 2) */}
                                {((inventoryform?.franchise_id !== 2) && (inventoryform?.hub_setup === 'pincode' || inventoryform?.hub_setup === 'radius_and_pincode')) || (inventoryform?.franchise_id === 2) ? (
                                <Box sx={{ display: "flex", gap: "16px", mb: 2, flexWrap: "wrap" }}>
                                    <Box sx={{ minWidth: "150px", flex: 1 }}>
                                        <Typography sx={{ fontSize: "12px", mb: 1 }}>Pincode</Typography>
                                        <InputBase
                                            value={item.pincode}
                                            name="pincode"
                                            disabled={isFieldDisabledForSupervisor('pincode')}
                                            onChange={(e) => handlePincodeChange(e, index)}
                                            placeholder="Pincode"
                                            sx={inputStyles}
                                        />
                                        {errors?.[`pincodes[${index}].pincode`] && (
                                            <Typography sx={{ color: "red", fontSize: "10px", mt: 0.5 }}>
                                                {errors[`pincodes[${index}].pincode`]}
                                            </Typography>
                                        )}
                                    </Box>
                                    <Box sx={{ minWidth: "150px", flex: 1 }}>
                                        <Typography sx={{ fontSize: "12px", mb: 1 }}>Latitude</Typography>
                                        <InputBase
                                            type="number"
                                            step="any"
                                            value={item.latitude}
                                            name="latitude"
                                            disabled={isFieldDisabledForSupervisor('latitude')}
                                            onChange={(e) => handlePincodeChange(e, index)}
                                            placeholder="Latitude"
                                            sx={inputStyles}
                                        />
                                        {errors?.[`pincodes[${index}].latitude`] && (
                                            <Typography sx={{ color: "red", fontSize: "10px", mt: 0.5 }}>
                                                {errors[`pincodes[${index}].latitude`]}
                                            </Typography>
                                        )}
                                    </Box>
                                    <Box sx={{ minWidth: "150px", flex: 1 }}>
                                        <Typography sx={{ fontSize: "12px", mb: 1 }}>Longitude</Typography>
                                        <InputBase
                                            type="number"
                                            step="any"
                                            value={item.longitude}
                                            name="longitude"
                                            disabled={isFieldDisabledForSupervisor('longitude')}
                                            onChange={(e) => handlePincodeChange(e, index)}
                                            placeholder="Longitude"
                                            sx={inputStyles}
                                        />
                                        {errors?.[`pincodes[${index}].longitude`] && (
                                            <Typography sx={{ color: "red", fontSize: "10px", mt: 0.5 }}>
                                                {errors[`pincodes[${index}].longitude`]}
                                            </Typography>
                                        )}
                                    </Box>
                                </Box>
                                ) : null}

                                {/* Hub Lat/Lon for 'radius' or 'boundary' (no pincode) */}
                                {inventoryform?.franchise_id !== 2 && (inventoryform?.hub_setup === 'radius' || inventoryform?.hub_setup === 'boundary') && (
                                <Box sx={{ display: "flex", gap: "16px", mb: 2, flexWrap: "wrap" }}>
                                    <Box sx={{ minWidth: "150px", flex: 1 }}>
                                        <Typography sx={{ fontSize: "12px", mb: 1 }}>Latitude</Typography>
                                        <InputBase
                                            type="number"
                                            step="any"
                                            value={item.latitude}
                                            name="latitude"
                                            disabled={isFieldDisabledForSupervisor('latitude')}
                                            onChange={(e) => handlePincodeChange(e, index)}
                                            placeholder="Latitude"
                                            sx={inputStyles}
                                        />
                                        {errors?.[`pincodes[${index}].latitude`] && (
                                            <Typography sx={{ color: "red", fontSize: "10px", mt: 0.5 }}>
                                                {errors[`pincodes[${index}].latitude`]}
                                            </Typography>
                                        )}
                                    </Box>
                                    <Box sx={{ minWidth: "150px", flex: 1 }}>
                                        <Typography sx={{ fontSize: "12px", mb: 1 }}>Longitude</Typography>
                                        <InputBase
                                            type="number"
                                            step="any"
                                            value={item.longitude}
                                            name="longitude"
                                            disabled={isFieldDisabledForSupervisor('longitude')}
                                            onChange={(e) => handlePincodeChange(e, index)}
                                            placeholder="Longitude"
                                            sx={inputStyles}
                                        />
                                        {errors?.[`pincodes[${index}].longitude`] && (
                                            <Typography sx={{ color: "red", fontSize: "10px", mt: 0.5 }}>
                                                {errors[`pincodes[${index}].longitude`]}
                                            </Typography>
                                        )}
                                    </Box>
                                </Box>
                                )}

                                {/* Hub Address - show for franchise 2 or for any hub setup type */}
                                {(inventoryform?.franchise_id === 2 || ['pincode', 'radius_and_pincode', 'radius', 'boundary'].includes(inventoryform?.hub_setup)) && (
                                <Box sx={{ mb: 2 }}>
                                    <Typography sx={{ fontSize: "12px", mb: 1 }}>Hub Address</Typography>
                                    <InputBase
                                        value={item.hub_address}
                                        name="hub_address"
                                        disabled={isFieldDisabledForSupervisor('hub_address')}
                                        onChange={(e) => handlePincodeChange(e, index)}
                                        placeholder="Hub Address"
                                        sx={{...inputStyles, width: "100%"}}
                                    />
                                    {errors?.[`pincodes[${index}].hub_address`] && (
                                        <Typography sx={{ color: "red", fontSize: "10px", mt: 0.5 }}>
                                            {errors[`pincodes[${index}].hub_address`]}
                                        </Typography>
                                    )}
                                </Box>
                                )}

                                {/* Radius Configuration Row - show for 'radius' and 'radius_and_pincode' when not FoodFix */}
                                {inventoryform?.franchise_id !== 2 && (inventoryform?.hub_setup === 'radius' || inventoryform?.hub_setup === 'radius_and_pincode') && (
                                    <>
                                        <Typography sx={{ fontSize: "13px", fontWeight: "500", mb: 1, color: "#666" }}>Radius Configuration</Typography>
                                        <Box sx={{ display: "flex", gap: "16px", mb: 2, flexWrap: "wrap" }}>
                                            <Box sx={{ minWidth: "150px", flex: 1 }}>
                                                <Typography sx={{ fontSize: "12px", mb: 1 }}>Radius (km)</Typography>
                                                <InputBase
                                                    type="number"
                                                    step="0.01"
                                                    value={item.inner_radius}
                                                    name="inner_radius"
                                                    disabled={isFieldDisabledForSupervisor('inner_radius')}
                                                    onChange={(e) => handlePincodeChange(e, index)}
                                                    placeholder="Inner Radius"
                                                    sx={inputStyles}
                                                />
                                            </Box>
                                            {/* Outer Radius - commented out for future use */}
                                            {/* <Box sx={{ minWidth: "150px", flex: 1 }}>
                                                <Typography sx={{ fontSize: "12px", mb: 1 }}>Outer Radius (km)</Typography>
                                                <InputBase
                                                    type="number"
                                                    step="0.01"
                                                    value={item.outter_radius}
                                                    name="outter_radius"
                                                    disabled={isFieldDisabledForSupervisor('outter_radius')}
                                                    onChange={(e) => handlePincodeChange(e, index)}
                                                    placeholder="Outer Radius"
                                                    sx={inputStyles}
                                                />
                                            </Box> */}
                                            {/* Fee to increase the radius - commented out for future use */}
                                            {/* <Box sx={{ minWidth: "150px", flex: 1 }}>
                                                <Typography sx={{ fontSize: "12px", mb: 1 }}>Radius Increase Fee</Typography>
                                                <InputBase
                                                    type="number"
                                                    step="0.01"
                                                    value={item.radius_increase_delivery_fee}
                                                    name="radius_increase_delivery_fee"
                                                    disabled={isFieldDisabledForSupervisor('radius_increase_delivery_fee')}
                                                    onChange={(e) => handlePincodeChange(e, index)}
                                                    placeholder="Increase Fee"
                                                    sx={inputStyles}
                                                />
                                            </Box> */}
                                        </Box>
                                    </>
                                )}

                                {/* Boundary Coordinates - show only for 'boundary' when not FoodFix */}
                                {inventoryform?.franchise_id !== 2 && (inventoryform?.hub_setup === 'boundary') && (
                                    <>
                                        <Typography sx={{ fontSize: "13px", fontWeight: "500", mb: 1, color: "#666" }}>Boundary Coordinates</Typography>
                                        {/* North */}
                                        <Box sx={{ display: "flex", gap: "16px", mb: 1, flexWrap: "wrap" }}>
                                            <Box sx={{ minWidth: "150px", flex: 1 }}>
                                                <Typography sx={{ fontSize: "12px", mb: 1 }}>North Latitude</Typography>
                                                <InputBase
                                                    type="number"
                                                    step="any"
                                                    value={item.north_latitude}
                                                    name="north_latitude"
                                                    disabled={isFieldDisabledForSupervisor('north_latitude')}
                                                    onChange={(e) => handlePincodeChange(e, index)}
                                                    placeholder="North Lat"
                                                    sx={inputStyles}
                                                />
                                            </Box>
                                            <Box sx={{ minWidth: "150px", flex: 1 }}>
                                                <Typography sx={{ fontSize: "12px", mb: 1 }}>North Longitude</Typography>
                                                <InputBase
                                                    type="number"
                                                    step="any"
                                                    value={item.north_longitude}
                                                    name="north_longitude"
                                                    disabled={isFieldDisabledForSupervisor('north_longitude')}
                                                    onChange={(e) => handlePincodeChange(e, index)}
                                                    placeholder="North Long"
                                                    sx={inputStyles}
                                                />
                                            </Box>
                                        </Box>

                                        {/* South */}
                                        <Box sx={{ display: "flex", gap: "16px", mb: 1, flexWrap: "wrap" }}>
                                            <Box sx={{ minWidth: "150px", flex: 1 }}>
                                                <Typography sx={{ fontSize: "12px", mb: 1 }}>South Latitude</Typography>
                                                <InputBase
                                                    type="number"
                                                    step="any"
                                                    value={item.south_latitude}
                                                    name="south_latitude"
                                                    disabled={isFieldDisabledForSupervisor('south_latitude')}
                                                    onChange={(e) => handlePincodeChange(e, index)}
                                                    placeholder="South Lat"
                                                    sx={inputStyles}
                                                />
                                            </Box>
                                            <Box sx={{ minWidth: "150px", flex: 1 }}>
                                                <Typography sx={{ fontSize: "12px", mb: 1 }}>South Longitude</Typography>
                                                <InputBase
                                                    type="number"
                                                    step="any"
                                                    value={item.south_longitude}
                                                    name="south_longitude"
                                                    disabled={isFieldDisabledForSupervisor('south_longitude')}
                                                    onChange={(e) => handlePincodeChange(e, index)}
                                                    placeholder="South Long"
                                                    sx={inputStyles}
                                                />
                                            </Box>
                                        </Box>

                                        {/* East */}
                                        <Box sx={{ display: "flex", gap: "16px", mb: 1, flexWrap: "wrap" }}>
                                            <Box sx={{ minWidth: "150px", flex: 1 }}>
                                                <Typography sx={{ fontSize: "12px", mb: 1 }}>East Latitude</Typography>
                                                <InputBase
                                                    type="number"
                                                    step="any"
                                                    value={item.east_latitude}
                                                    name="east_latitude"
                                                    disabled={isFieldDisabledForSupervisor('east_latitude')}
                                                    onChange={(e) => handlePincodeChange(e, index)}
                                                    placeholder="East Lat"
                                                    sx={inputStyles}
                                                />
                                            </Box>
                                            <Box sx={{ minWidth: "150px", flex: 1 }}>
                                                <Typography sx={{ fontSize: "12px", mb: 1 }}>East Longitude</Typography>
                                                <InputBase
                                                    type="number"
                                                    step="any"
                                                    value={item.east_longitude}
                                                    name="east_longitude"
                                                    disabled={isFieldDisabledForSupervisor('east_longitude')}
                                                    onChange={(e) => handlePincodeChange(e, index)}
                                                    placeholder="East Long"
                                                    sx={inputStyles}
                                                />
                                            </Box>
                                        </Box>

                                        {/* West */}
                                        <Box sx={{ display: "flex", gap: "16px", mb: 1, flexWrap: "wrap" }}>
                                            <Box sx={{ minWidth: "150px", flex: 1 }}>
                                                <Typography sx={{ fontSize: "12px", mb: 1 }}>West Latitude</Typography>
                                                <InputBase
                                                    type="number"
                                                    step="any"
                                                    value={item.west_latitude}
                                                    name="west_latitude"
                                                    disabled={isFieldDisabledForSupervisor('west_latitude')}
                                                    onChange={(e) => handlePincodeChange(e, index)}
                                                    placeholder="West Lat"
                                                    sx={inputStyles}
                                                />
                                            </Box>
                                            <Box sx={{ minWidth: "150px", flex: 1 }}>
                                                <Typography sx={{ fontSize: "12px", mb: 1 }}>West Longitude</Typography>
                                                <InputBase
                                                    type="number"
                                                    step="any"
                                                    value={item.west_longitude}
                                                    name="west_longitude"
                                                    disabled={isFieldDisabledForSupervisor('west_longitude')}
                                                    onChange={(e) => handlePincodeChange(e, index)}
                                                    placeholder="West Long"
                                                    sx={inputStyles}
                                                />
                                            </Box>
                                        </Box>
                                    </>
                                )}

                                {/* Remove Button */}
                                <Tooltip title="Remove this location" arrow>
                                    <IconButton
                                        onClick={() => handleRemoveItem(index)}
                                        sx={{ position: "absolute", top: "8px", right: "8px", color: "error.main" }}
                                        disabled={isFieldDisabledForSupervisor('remove_pincode')}
                                    >
                                        <CancelOutlinedIcon />
                                    </IconButton>
                                </Tooltip>
                            </Box>
                        ))}

                        <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
                            <Button variant="outlined" sx={{ border: "2px dotted", borderColor: "secondary.border", width: "100%" }} onClick={handleAddPincode} disabled={isFieldDisabledForSupervisor('add_pincode')}><Typography sx={{ fontSize: "14px", fontWeight: "400", lineHeight: "22px", color: "black" }} >Add Pincode</Typography></Button>
                        </Box>
                    </Box>
                    <Box >
                    </Box>
                    <Box sx={{ backgroundColor: "#EEEEEE", display: "flex", alignItems: "center", position: "absolute", bottom: 0, display: "flex", justifyContent: "flex-end", width: "100%" }}>
                        <Box sx={{ padding: "12px 24px", display: "flex", gap: "20px" }}>
                            {/* Show edit buttons for non-view-only mode or for supervisors editing allowed fields */}
                            {(!inventoryform.isViewOnly || (user_role === 'supervisor' && InventoryEdit)) && (
                                <>
                                    <Button variant="outlined" sx={{ textTransform: "none", color: "black", backgroundColor: "white", height: "32px", width: "67px" }} onClick={handleCloseInventoryModal}> cancel</Button>
                                    <Button variant="contained" sx={{ textTransform: "none", height: "32px", width: "67px" }} onClick={() => InventoryEdit ? handleEditInventory(inventoryform.value) : handleSaveInventory()} > {InventoryEdit ? loading ? <CircularProgress size="25px" sx={{ color: "white" }} /> : 'update' : loading ? <CircularProgress size="25px" sx={{ color: "white" }} /> : 'Save'}</Button>
                                </>
                            )}
                            {/* Show close button for view-only mode (but not for supervisors editing) */}
                            {inventoryform.isViewOnly && !(user_role === 'supervisor' && InventoryEdit) && (
                                <Button variant="outlined" sx={{ textTransform: "none", color: "black", backgroundColor: "white", height: "32px", width: "67px" }} onClick={handleCloseInventoryModal}> Close</Button>
                            )}
                        </Box>
                    </Box>
                </Box>
            </Modal>

            {/* Stall Modal */}
            <Modal
                open={stallModal}
                onClose={handleCloseStallModal}
                aria-labelledby="stall-modal-title"
                aria-describedby="stall-modal-description"
                sx={{ zIndex: 1000 }}
            >
                <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: '100%', maxWidth: "600px", height: "600px", backgroundColor: 'white' }}>
                    <Box sx={{ height: "46px", padding: "12px 24px", backgroundColor: "#EEEEEE", display: "flex", alignItems: "center" }}>
                        <Typography sx={{ fontSize: "14", fontWeight: "500", lineHeight: "22px" }}>
                            {stallForm.isViewOnly ? 'View Stall Details' : (stallEdit ? 'Edit Stall' : 'Add Stall')}
                        </Typography>
                    </Box>
                    <Box sx={{ display: "flex", flexDirection: "column", gap: "16px", padding: "30px", height: '500px', overflow: 'auto' }}>
                        <Box sx={{ display: "flex", gap: "16px" }}>
                            <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }}>Hub</Typography>
                                <Dropdown 
                                    onChange={handleChangeStall} 
                                    value={stallform.hub} 
                                    options={filteredHubOptions} 
                                    name="hub" 
                                    optionLabel="name" 
                                    optionValue="value"
                                    style={{ zIndex: "1000" }}
                                    placeholder="Select hub" 
                                    className="w-full md:w-20rem" 
                                    disabled={isStallFieldDisabledForSupervisor('hub')}
                                />
                                {stallErrors.hub && <Typography style={{ color: "red", fontSize: "12PX", fontWeight: "400", lineHeight: "22px" }}>{stallErrors.hub}</Typography>}
                            </Box>
                            <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }}>Stall Name</Typography>
                                <InputBase 
                                    value={stallform.stall_name} 
                                    sx={{ backgroundColor: "white", width: "100%", height: "32px", borderRadius: "2px", border: "1px solid", borderColor: "secondary.border", padding: "5px 12px", fontSize: "14px", fontWeight: "400", lineHeight: "22px", color: "black" }} 
                                    placeholder="Enter stall name" 
                                    name="stall_name" 
                                    onChange={handleChangeStall} 
                                    disabled={isStallFieldDisabledForSupervisor('stall_name')}
                                />
                                {stallErrors.stall_name && <Typography style={{ color: "red", fontSize: "12PX", fontWeight: "400", lineHeight: "22px" }}>{stallErrors.stall_name}</Typography>}
                            </Box>
                        </Box>

                        <Box sx={{ display: "flex", gap: "16px" }}>
                            <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }}>Pincode</Typography>
                                <InputBase 
                                    value={stallform.pincode} 
                                    sx={{ backgroundColor: "white", width: "100%", height: "32px", borderRadius: "2px", border: "1px solid", borderColor: "secondary.border", padding: "5px 12px", fontSize: "14px", fontWeight: "400", lineHeight: "22px", color: "black" }} 
                                    placeholder="Enter pincode (6 digits)" 
                                    name="pincode" 
                                    onChange={handleChangeStall} 
                                    disabled={isStallFieldDisabledForSupervisor('pincode')}
                                />
                                {stallErrors.pincode && <Typography style={{ color: "red", fontSize: "12PX", fontWeight: "400", lineHeight: "22px" }}>{stallErrors.pincode}</Typography>}
                            </Box>
                            <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }}>Icon URL</Typography>
                                <InputBase 
                                    value={stallform.icon_url} 
                                    sx={{ backgroundColor: "white", width: "100%", height: "32px", borderRadius: "2px", border: "1px solid", borderColor: "secondary.border", padding: "5px 12px", fontSize: "14px", fontWeight: "400", lineHeight: "22px", color: "black" }} 
                                    placeholder="Enter icon URL (optional)" 
                                    name="icon_url" 
                                    onChange={handleChangeStall} 
                                    disabled={isStallFieldDisabledForSupervisor('icon_url')}
                                />
                                {stallErrors.icon_url && <Typography style={{ color: "red", fontSize: "12PX", fontWeight: "400", lineHeight: "22px" }}>{stallErrors.icon_url}</Typography>}
                            </Box>
                        </Box>

                        <Box sx={{ display: "flex", gap: "16px" }}>
                            <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }}>Latitude</Typography>
                                <InputBase 
                                    type="number"
                                    step="any"
                                    value={stallform.latitude} 
                                    sx={{ backgroundColor: "white", width: "100%", height: "32px", borderRadius: "2px", border: "1px solid", borderColor: "secondary.border", padding: "5px 12px", fontSize: "14px", fontWeight: "400", lineHeight: "22px", color: "black" }} 
                                    placeholder="Enter latitude" 
                                    name="latitude" 
                                    onChange={handleChangeStall} 
                                    disabled={isStallFieldDisabledForSupervisor('latitude')}
                                />
                                {stallErrors.latitude && <Typography style={{ color: "red", fontSize: "12PX", fontWeight: "400", lineHeight: "22px" }}>{stallErrors.latitude}</Typography>}
                            </Box>
                            <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }}>Longitude</Typography>
                                <InputBase 
                                    type="number"
                                    step="any"
                                    value={stallform.longitude} 
                                    sx={{ backgroundColor: "white", width: "100%", height: "32px", borderRadius: "2px", border: "1px solid", borderColor: "secondary.border", padding: "5px 12px", fontSize: "14px", fontWeight: "400", lineHeight: "22px", color: "black" }} 
                                    placeholder="Enter longitude" 
                                    name="longitude" 
                                    onChange={handleChangeStall} 
                                    disabled={isStallFieldDisabledForSupervisor('longitude')}
                                />
                                {stallErrors.longitude && <Typography style={{ color: "red", fontSize: "12PX", fontWeight: "400", lineHeight: "22px" }}>{stallErrors.longitude}</Typography>}
                            </Box>
                        </Box>

                        <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: "10px" }}>
                            <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }}>Stall Address</Typography>
                            <InputBase 
                                multiline
                                rows={3}
                                value={stallform.stall_address} 
                                sx={{ backgroundColor: "white", width: "100%", borderRadius: "2px", border: "1px solid", borderColor: "secondary.border", padding: "5px 12px", fontSize: "14px", fontWeight: "400", lineHeight: "22px", color: "black" }} 
                                placeholder="Enter complete stall address" 
                                name="stall_address" 
                                onChange={handleChangeStall} 
                                disabled={isStallFieldDisabledForSupervisor('stall_address')}
                            />
                            {stallErrors.stall_address && <Typography style={{ color: "red", fontSize: "12PX", fontWeight: "400", lineHeight: "22px" }}>{stallErrors.stall_address}</Typography>}
                        </Box>

                

                    </Box>
                    <Box sx={{ backgroundColor: "#EEEEEE", display: "flex", alignItems: "center", position: "absolute", bottom: 0, display: "flex", justifyContent: "flex-end", width: "100%" }}>
                        <Box sx={{ padding: "12px 24px", display: "flex", gap: "20px" }}>
                            {stallForm.isViewOnly ? (
                                <Button variant="outlined" sx={{ textTransform: "none", color: "black", backgroundColor: "white", height: "32px", width: "67px" }} onClick={handleCloseStallModal}>
                                    Close
                                </Button>
                            ) : (
                                <>
                                    <Button variant="outlined" sx={{ textTransform: "none", color: "black", backgroundColor: "white", height: "32px", width: "67px" }} onClick={handleCloseStallModal}>
                                        Cancel
                                    </Button>
                                    <Button variant="contained" sx={{ textTransform: "none", height: "32px", width: "67px" }} onClick={() => stallEdit ? handleEditStall(selectedStallId) : handleSaveStall()}>
                                        {stallEdit ? (loading ? <CircularProgress size="25px" sx={{ color: "white" }} /> : 'Update') : (loading ? <CircularProgress size="25px" sx={{ color: "white" }} /> : 'Save')}
                                    </Button>
                                </>
                            )}
                        </Box>
                    </Box>
                </Box>
            </Modal>
        </Box>
    )
}